"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeMessageForEdit = void 0;
var lodash_1 = __importDefault(require("lodash"));
var GetReactMentionsFormat_1 = require("./GetReactMentionsFormat");
var GetFullName_1 = __importDefault(require("@CommonFrontendBackend/Utils/GetFullName"));
var mergeMessageForEdit = function (message, mentions, usersInAccount) {
    var sortedMentions = lodash_1.default.orderBy(mentions, function (item) { return item.location; }, ["desc"]);
    var mergedMessage = sortedMentions.reduce(function (prevValue, currentMention) {
        var userId = currentMention.userId, location = currentMention.location;
        var mentionedUser = usersInAccount.find(function (s) { return s._id == userId; });
        var displayName = mentionedUser ? (0, GetFullName_1.default)(mentionedUser) : "Unknown user";
        var formattedBlock = (0, GetReactMentionsFormat_1.getReactMentionsFormat)(displayName, currentMention.userId || "");
        return prevValue.substring(0, location) + formattedBlock + prevValue.substring(location);
    }, message);
    return mergedMessage;
};
exports.mergeMessageForEdit = mergeMessageForEdit;
